import { IRender } from '../parseTreeToHtml.types';

export const boldRender: IRender = (text): string => {
  if (!text) {
    return '';
  }

  return `<b>${text}</b>`;
};
